export default [
	'/login'
]


// WEBPACK FOOTER //
// ./src/api/whitelist/index.js